// Compatibility with older public responses that return only ordered keys.
// A row with an explicit enabled value always takes precedence.
const LEGACY_NAV_FLAGS = {
  places: "FEATURE_PLACES_NAV",
  home: "FEATURE_PULSE_NAV",
  portfolio: "FEATURE_LOCATIONS_NAV",
  leases: "FEATURE_LEASES_NAV",
  plan: "FEATURE_PLAN_NAV",
  projects: "FEATURE_PROJECTS_NAV",
  reports: "FEATURE_REPORTS_NAV",
  radar: "FEATURE_RADAR_NAV",
  playbooks: "FEATURE_PLAYBOOKS_NAV",
  roadmap: "FEATURE_ROADMAP_NAV",
  workflows: "FEATURE_WORKFLOWS_NAV",
  okrs: "FEATURE_OKRS_NAV",
  reviews: "FEATURE_REVIEWS_NAV",
  signals: "FEATURE_SIGNALS_NAV",
};

const DEFAULT_ON_WHEN_MISSING = new Set(["portfolio"]);

export function dbNavKey(dbKey) {
  return { pulse: "home", locations: "portfolio" }[dbKey] ?? dbKey;
}

export function legacyFlagForNav(key) {
  return LEGACY_NAV_FLAGS[key] ?? `FEATURE_${key.toUpperCase()}_NAV`;
}

export function legacyNavEnabled(flags, key) {
  const flag = LEGACY_NAV_FLAGS[key];
  if (!flag) return false;
  return DEFAULT_ON_WHEN_MISSING.has(key)
    ? flags?.[flag] !== false
    : flags?.[flag] === true;
}

export function governedNavEnabled(flags, navConfig, key, navOrder) {
  // Existing callers can keep their grain-specific permission checks. Once the
  // Places contract is present, legacy rail keys cannot override its governance.
  if (["portfolio", "plan"].includes(key) &&
      (navConfig?.some((row) => row.key === "places") || Array.isArray(flags?.places_tabs))) {
    const lensKey = key === "portfolio" ? "places_offices" : "places_markets";
    return governedNavEnabled(flags, navConfig, "places", navOrder)
      && flags?.places_tabs?.some((row) => row.key === lensKey && row.enabled === true) === true;
  }
  // An explicit empty order is governance too: it permits no destinations.
  if (Array.isArray(navOrder) && !navOrder.some((entry) => (entry?.key ?? entry) === key)) {
    return false;
  }
  const row = Array.isArray(navConfig) ? navConfig.find((entry) => entry.key === key) : null;
  if (typeof row?.enabled === "boolean") return row.enabled;
  if (!Array.isArray(navOrder) && Array.isArray(navConfig) && navConfig.length > 0 && !row) return false;
  const orderRow = Array.isArray(navOrder)
    ? navOrder.find((entry) => entry?.key === key) : null;
  if (typeof orderRow?.enabled === "boolean") return orderRow.enabled;
  return legacyNavEnabled(flags, key);
}